import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Badge, Spinner, Alert } from 'react-bootstrap';
import api from "../../../api/axiosConfig"; // Import axios instance
import { useNavigate } from 'react-router-dom';

const Admins = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdmins = async () => {
      try {
        const response = await api.get('/users?role=site_admin'); // Fetch admins from API
        setAdmins(response.data.data || []); // Assuming the API returns { success: true, data: [...] }
      } catch (err) {
        console.error(err);
        setError('Failed to fetch administrators.');
      } finally {
        setLoading(false);
      }
    };

    fetchAdmins();
  }, []);

  const getStatusVariant = (status) => {
    return status === 'active' ? 'success' : 'secondary';
  };

  const getRoleVariant = (role) => {
    return role === 'Super Admin' ? 'primary' : 'info';
  };

  if (loading) {
    return (
      <Container className="text-center">
        <Spinner animation="border" />
        <p>Loading administrators...</p>
      </Container>
    );
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }

  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="h2 mb-2 fw-bold">Administrators</h1>
          <p className="text-muted mb-0">Manage system administrators</p>
        </div>
        <Button variant="primary" size="lg" onClick={() => navigate('/super-admin/admins/create')}>          <i className="fas fa-plus me-2"></i>
          Add Admin
        </Button>
      </div>
      <Card className="border-0 shadow-sm">
        <Card.Body className="p-0">
          <Table responsive className="mb-0">
            <thead className="bg-light">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Mobile</th>
                <th>Last Login</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {admins.map((admin) => (
                <tr key={admin.id}>
                  <td>
                    <div className="fw-semibold">{admin.name}</div>
                  </td>
                  <td>{admin.email}</td>
                  <td>
                    <Badge bg={getRoleVariant(admin.role)}>
                      {admin.role}
                    </Badge>
                  </td>
                  <td>
                    <Badge bg={getStatusVariant(admin.status === 1 ? 'active' : 'inactive')}>
                      {admin.status === 1 ? 'active' : 'inactive'}
                    </Badge>
                  </td>
                  <td>{admin.mobile}</td>
                  <td>{admin.lastLogin}</td>
                  <td className="text-end">
                    <div className="d-flex justify-content-end gap-2">

                      <Button variant="outline-primary" size="sm" onClick={() => navigate(`/super-admin/admins/edit/${admin.id}`)}>
                        <i className="fas fa-edit"></i>
                      </Button>
                      <Button variant="outline-danger" size="sm">
                        <i className="fas fa-trash"></i>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Admins;